import {NewsEntitiesState} from '../states/news-entities.state';
import {createReducer, on} from '@ngrx/store';
import {newsEntitiesAdapter} from '../adapter/news-entities.adapters';
import {NewsEntitiesActions} from '../action/news-entities.actions';


export const newsEntitiesStateInitial: NewsEntitiesState = newsEntitiesAdapter.getInitialState({
  totalElements: 0,
  loadingState: {
    newsLoading: false,
    newsLoaded: false,
    imagesLoading: false,
    imagesLoaded: false,
  }
});

let imageLoadingCount = 0;

export const newsEntitiesReducer = createReducer(
  newsEntitiesStateInitial,

  on(NewsEntitiesActions.readNews, (state) => ({
    ...state,
    loadingState: {
      ...state.loadingState,
      newsLoading: true,
      newsLoaded: false,
    },
  })),

  on(NewsEntitiesActions.readNewsSuccess, (state, {newsDtos, pageIndex, totalElements}) => {
    const newsWithPageIndex = newsDtos.map(news => ({
      ...news,
      pageIndex,
    }));

    return newsEntitiesAdapter.upsertMany(newsWithPageIndex, {
      ...state,
      totalElements,
      loadingState: {
        ...state.loadingState,
        newsLoading: false,
        newsLoaded: true,
      },
    });
  }),

  on(NewsEntitiesActions.getNewsById, (state, {newsId}) => {
    return {
      ...state,
      loadingState: {
        ...state.loadingState,
        newsLoading: true,
      },
    };
  }),

  on(NewsEntitiesActions.getNewsByIdSuccess, (state, {newsDto}) => {
    return newsEntitiesAdapter.upsertOne(newsDto, {
      ...state,
      loadingState: {
        ...state.loadingState,
        newsLoading: false,
      },
    });
  }),

  on(NewsEntitiesActions.getNewsByIdFailure, (state) => ({
    ...state,
    loadingState: {
      ...state.loadingState,
      newsLoading: false,
    },
  })),

  on(NewsEntitiesActions.readNewsFailure, (state) => ({
    ...state,
    loadingState: {
      ...state.loadingState,
      newsLoading: false,
      newsLoaded: false,
    },
  })),

);
